import { render, staticRenderFns } from "./PositionEditor.vue?vue&type=template&id=557bbe48"
import script from "./PositionEditor.vue?vue&type=script&lang=js"
export * from "./PositionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports